import FilterIcon from './component.jsx'
export default FilterIcon
